import store from '@/store';
import { fetchEventSource }  from '@microsoft/fetch-event-source';
const defaultRootURL = store.state.defaultRootURL;

const getHeaders = (headers)=>{
  const token = localStorage.getItem("userToken");
  const checkToken = localStorage.getItem("checkToken");
  const defaultHeaders = {
    Authorization: token,
    checkToken: checkToken,
    token: token,
    'Content-Type': 'application/json',
  }
  return Object.assign(defaultHeaders, headers);
}

export const fetchInit = (url, headers, data)=>{
  const requestHeaders = getHeaders(headers);
  return fetch(`${defaultRootURL}${url}`, {
    method: 'POST',
    headers: requestHeaders,
    body: JSON.stringify(data),
  })
}

export const fetchEventSourceInit = (url, headers, data, messageConfig)=>{
  const requestHeaders = getHeaders(headers);
  return fetchEventSource(`${defaultRootURL}${url}`, {
    method: 'POST',
    headers: requestHeaders,
    body: JSON.stringify(data),
    ...messageConfig,
  })
}